import { brandDeleted } from 'services/typewriter';
import { flatten } from 'inc/utils';
import {
  getEntity,
  segmentBrandObject,
  segmentCompanyObject,
  segmentContextObject,
} from './helpers';

export default async ({ data: values }: Data) => {
  const brand = flatten(values);
  const company = await getEntity('companies', brand['company']);
  brandDeleted({
    context: segmentContextObject(company, brand),
    brand: segmentBrandObject(brand, company),
    company: segmentCompanyObject(company),
  });
  window.analytics.group(brand['id'], {
    company: segmentCompanyObject(company),
    brand: segmentBrandObject(brand, company),
  });
};
